import React from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";

function Contact() {
  return (
    <div className="contact privacy">
      <Header />
      <div className="section-stack">
        <div className="section-header justify-self-center text-center">
          <h1 className="h2">Contact</h1>
        </div>
        <div id="dynamic-rows" className="prose">
          <div style={{ textAlign: "center" }}>
            <h4>General Inquiries &amp; Orders</h4>
            <a
              href="mailto:main@ownmarketplace.xyz"
              target="_blank"
              rel="noreferrer"
            >
              main@ownmarketplace.xyz
            </a>
            <br />
            <br />
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <div style={{ textAlign: "center" }}>
            <h4>Press</h4>
            <a
              href="mailto:main@ownmarketplace.xyz"
              target="_blank"
              rel="noreferrer"
            >
              main@ownmarketplace.xyz
            </a>
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <p style={{ textAlign: "center" }}>
            ACK MARKETS LIMITED <br />
            RM 701, UNIT 108B, 7/F, TWR B NEW MANDARIN PLAZA 14 SCIENCE MUSEUM
            RD TSIM SHA TSUI
            <br />
            HONG KONG
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
